import { useEffect, useState } from "react";
import { AuthInterceptor } from "../../services/AuthInterceptor.Service";
import Spinnerr from "../Commaon/Spinner";
import Toaster from "../Commaon/Toaster";
import { CgPen } from "react-icons/cg";
import { Modal } from "react-bootstrap";

const PredefinedSlotsList = () => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState(null);

  // pagination states
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);

  // edit states
  const [editModel, setEditModel] = useState(false);
  const [addSlots, setAddSlots] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editFrom, setEditFrom] = useState("");
  const [addFrom, setAddFrom] = useState("");
  const [editTo, setEditTo] = useState("");
  const [addTo, setAddTo] = useState("");

  const getSlots = async () => {
    setLoading(true);
    try {
      const response = await AuthInterceptor(`/admin/slots`, { method: "GET" });
      const data = response.data;
      if (data.s === 200) setSlots(data.r || []);
    } catch (err) {
      console.error("Failed to fetch slots:", err);
      setSnack({
        notification: { message: "Error fetching slots", type: "error" },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSlots();
  }, []);

  const toggleStatus = async (slot) => {
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slots/active-deactive`, {
        method: "POST",
        body: { isActive: !slot.isActive, slotId: slot._id },
      });
      const data = response.data;

      if (data.s === 200) {
        setSlots((prev) =>
          prev.map((s) =>
            s._id === slot._id ? { ...s, isActive: !s.isActive } : s
          )
        );
        setSnack({
          notification: {
            message: `Slot ${
              slot.isActive ? "deactivated" : "activated"
            } successfully`,
            type: "success",
          },
        });
      }
    } catch (err) {
      console.error("Error toggling status:", err);
      setSnack({
        notification: { message: "Error updating status", type: "error" },
      });
    } finally {
      setLoading(false);
    }
  };

  const editSlot = async (slot) => {
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slots/${slot._id}`, {
        method: "GET",
      });
      const data = response?.data?.r || slot;
      setEditId(slot._id);
      setEditFrom(data.startTime);
      setEditTo(data.endTime);
      setEditModel(true);
    } catch (err) {
      setEditId(slot._id);
      setEditFrom(slot.startTime);
      setEditTo(slot.endTime);
      setEditModel(true);
    } finally {
      setLoading(false);
    }
  };
  // add slot states
  const handleAddSlot = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slots`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          startTime: addFrom,
          endTime: addTo,
        }),
      });

      const data = response.data;
      if (data.s === 201) {
        setSlots((prev) => [...prev, data.r]);
         setSnack({
          notification: {
            message: "Slot Added successfully",
            type: "success",
          },
        });
      }
    } catch (err) {
      console.error("Error adding slot:", err);
      setSnack({
        notification: { message: "Error adding slot", type: "error" },
      });
    } finally {
      setLoading(false);
      setAddSlots(false);
      setAddFrom("");
      setAddTo("");
    }
  };

  const handleEditSlot = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/slots/${editId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          startTime: editFrom,
          endTime: editTo,
        }),
      });

      const data = response.data;

      if (data.s === 200) {
        setSlots((prev) =>
          prev.map((s) =>
            s._id === editId
              ? { ...s, startTime: editFrom, endTime: editTo }
              : s
          )
        );
        setSnack({
          notification: {
            message: "Slot updated successfully",
            type: "success",
          },
        });
      }
    } catch (err) {
      console.error("Error updating slot:", err);
      setSnack({
        notification: { message: "Error updating slot", type: "error" },
      });
    } finally {
      setLoading(false);
      setEditModel(false);
      setEditId(null);
    }
  };

  // pagination slice
  const startIndex = (pageNo - 1) * limit;
  const paginatedSlots = slots.slice(startIndex, startIndex + limit);

  return (
    <>
      {loading && <Spinnerr show={loading} />}
      {snack && (
        <Toaster
          notification={snack.notification}
          onClose={() => setSnack(null)}
        />
      )}

      <div className="card shadow-sm border-0 rounded-3 p-3">
        {/* Header + Page Size */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 mr-3 gap-3">
          <h2 className="mb-2 mb-md-0">Predefined Slots</h2>
          <div className="d-flex flex-row  align-items-center gap-3">
            <button
              className="btn btn-sm btn-outline-custom text-nowrap"
              onClick={() => setAddSlots(true)}
              disabled={loading}
            >
              Add Slots
            </button>
            <select
              className="form-select form-select-sm"
              value={limit}
              onChange={(e) => {
                setPageNo(1);
                setLimit(Number(e.target.value));
              }}
            >
              {[5, 10, 20, 50].map((size) => (
                <option key={size} value={size}>
                  {size} per page
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive">
          <table className="table table-hover align-middle" style={{ tableLayout: "fixed", width: "100%" }}>
            <thead className="table-light">
              <tr>
                <th style={{ width: "25%" }}>Sr.</th>
                <th style={{ width: "25%" }}>From</th>
                <th style={{ width: "25%" }}>To</th>
                <th style={{ width: "25%" }}>Status</th>
                <th style={{ width: "25%" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedSlots.length > 0 ? (
                paginatedSlots.map((slot, idx) => (
                  <tr key={slot._id}>
                    <td>{startIndex + idx + 1}</td>
                    <td>{slot.startTime || "-"}</td>
                    <td>{slot.endTime || "-"}</td>
                    <td>
                      <span
                        role="button"
                        onClick={() => toggleStatus(slot)}
                        className={`badge ${
                          slot.isActive ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {slot.isActive ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-custom"
                        onClick={() => editSlot(slot)}
                      >
                        <CgPen size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-4">
                    No slots found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex flex-wrap justify-content-between align-items-center m-3 gap-2">
          <button
            className="btn btn-outline-custom btn-sm"
            onClick={() => setPageNo((prev) => Math.max(prev - 1, 1))}
            disabled={pageNo === 1}
          >
            Prev
          </button>
          <span className="mx-2">
            Page {pageNo} of {Math.ceil(slots.length / limit) || 1}
          </span>
          <button
            className="btn btn-outline-custom btn-sm"
            onClick={() =>
              setPageNo((prev) =>
                prev < Math.ceil(slots.length / limit) ? prev + 1 : prev
              )
            }
            disabled={pageNo >= Math.ceil(slots.length / limit)}
          >
            Next
          </button>
        </div>
      </div>

      {/*Add Slots Modal */}
      <Modal show={addSlots} onHide={() => setAddSlots(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAddSlot}>
            <div className="mb-3">
              <label className="form-label">From</label>
              <input
                type="time"
                className="form-control"
                value={addFrom}
                onChange={(e) => setAddFrom(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">To</label>
              <input
                type="time"
                className="form-control"
                value={addTo}
                onChange={(e) => setAddTo(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? <Spinnerr show={loading} /> : "Add Slot"}
            </button>
          </form>
        </Modal.Body>
      </Modal>

      {/* Edit Slot Modal */}
      <Modal show={editModel} onHide={() => setEditModel(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleEditSlot}>
            <div className="mb-3">
              <label className="form-label">From</label>
              <input
                type="time"
                className="form-control"
                value={editFrom}
                onChange={(e) => setEditFrom(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">To</label>
              <input
                type="time"
                className="form-control"
                value={editTo}
                onChange={(e) => setEditTo(e.target.value)}
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? <Spinnerr show={loading} /> : "Update Slot"}
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PredefinedSlotsList;
